import { render } from "./ServiceLogs.vue?vue&type=template&id=5297ee62&scoped=true&ts=true"
import script from "./ServiceLogs.vue?vue&type=script&lang=ts"
export * from "./ServiceLogs.vue?vue&type=script&lang=ts"

import "./ServiceLogs.vue?vue&type=style&index=0&id=5297ee62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5297ee62"]])

export default __exports__